import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { get, omit, unset } from 'lodash'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { themeColors } from '../styles/theme'
import {
  getItemDetail,
  unloadItemDetail,
  iWant,
  iWantNot,
  setItemNotOwned,
  ownedItemUpdated,
  checkCanSwapItem,
  checkCanProposeSwapItem,
  removeInterest,
} from '../actions'
import { getUserCanSwap } from '../selectors'
import ObjectDetail from '../common/ObjectDetail'
import Spinner from '../common/Spinner'
import ErrorPage from '../common/ErrorPage'
import NotFound from '../common/NotFound'
import OwnedForm from '../common/OwnedForm'
import BuyForm from '../common/BuyForm'
import {
  getObjectConditions,
  parseQsId,
  getObjectOwner,
  isExternalItemId,
} from '../utils'
import { makeAuthenticatedApi } from '../api'

import ReactModal from 'react-modal'
import Close from 'material-ui/svg-icons/navigation/close'
import IconButton from 'material-ui/IconButton'

const modalStyles = {
  header: {
    height: 52,
    backgroundColor: themeColors.positive,
    color: themeColors.white,
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 111111,
  },
  scrolling: {
    overflow: 'scroll',
    padding: 10,
    paddingTop: 60,
  },
}

class ObjectDetailPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      ownedFormOpen: false,
      editFormOpen: false,
      notOwnedDialogOpen: false,
      buyFormOpen: false,
      userCantSwapModalOpen: false,
      viewedImage: null,
      removeInterestOpen: false,
    }
  }

  componentDidMount() {
    this.props.getItemDetail(this.props.match.params.id)
  }

  componentWillReceiveProps(nextProps) {
    // New item id load new item
    if (
      this.props.match.params.id !== nextProps.match.params.id &&
      // Prevent to reload when the prev item is the next but no more external
      !(nextProps.item &&
        !isExternalItemId(nextProps.match.params.id) &&
        this.props.match.params.id === nextProps.item.external_id)
    ) {
      this.setState({ viewedImage: null })
      this.props.unloadItemDetail()
      this.props.getItemDetail(nextProps.match.params.id)
    }

    if (this.props.ownerUserId !== nextProps.ownerUserId) {
      this.setState({ viewedImage: null })
    }

    // Posso scambiare il mio oggetto con qualocosa?
    if (
      nextProps.user &&
      nextProps.item &&
      // Oggetto mio
      getObjectOwner(nextProps.item, nextProps.user.id) &&
      // O prima non c'era o prima non era mio
      (!this.props.item || !getObjectOwner(this.props.item, nextProps.user.id))
    ) {
      this.props.checkCanSwapItem(nextProps.item.id)
    }

    // Posso proporre uno scambio per quell'oggetto?
    if (
      nextProps.user &&
      nextProps.item &&
      // Oggetto non mio
      !getObjectOwner(nextProps.item, nextProps.user.id)
    ) {
      const currentOwnerId = get(
        this.getOwner(nextProps.ownerUserId, nextProps.item),
        'user.id'
      )
      const previousOwnerId = get(
        this.getOwner(this.props.ownerUserId, this.props.item),
        'user.id'
      )
      // Owner cambiato
      if (currentOwnerId && currentOwnerId !== previousOwnerId) {
        this.props.checkCanProposeSwapItem(nextProps.item.id, currentOwnerId)
      }
    }

    // This sounds crazy but, this means user not owned item anymore =D
    if (
      nextProps.user &&
      this.props.item &&
      nextProps.item &&
      this.props.item.id === nextProps.item.id &&
      this.props.item.posseduto_da !== nextProps.item.posseduto_da &&
      getObjectOwner(this.props.item, nextProps.user.id) &&
      !getObjectOwner(nextProps.item, nextProps.user.id)
    ) {
      this.props.history.replace(`/item/${nextProps.item.id}`)
    }

    // One more crazy condition, this means external item created <.<
    if (
      nextProps.item &&
      !isExternalItemId(nextProps.item.id) &&
      this.props.item !== nextProps.item &&
      this.props.match.params.id === nextProps.item.external_id
    ) {
      this.props.history.replace(`/item/${nextProps.item.id}`)
    }

    if (nextProps.interestRemoved) {
      this.props.history.push(`/me/items/wanted/interessi`)
    }
  }

  componentWillUnmount() {
    this.props.unloadItemDetail()
  }

  toggleInterestModal = () => {
    this.setState(state => ({
      removeInterestOpen: !this.state.removeInterestOpen,
    }))
  }

  toggleOwnedFormOpen = () => {
    this.setState(state => ({ ownedFormOpen: !state.ownedFormOpen }))
  }

  toggleNotOwnedDialogOpen = () => {
    this.setState(state => ({ notOwnedDialogOpen: !state.notOwnedDialogOpen }))
  }

  toggleEditFormOpen = () => {
    this.setState(state => ({ editFormOpen: !state.editFormOpen }))
  }

  toggleBuyFormOpen = () => {
    this.setState(state => ({ buyFormOpen: !state.buyFormOpen }))
  }

  toggleUserCantSwapModalOpen = () => {
    this.setState(state => ({
      userCantSwapModalOpen: !state.userCantSwapModalOpen,
    }))
  }

  setViewedImage = viewedImage => this.setState({ viewedImage })

  // Current object owner take from query stirng ?userId= and check if valid...
  // if not query return first owner if only one owner otherwise null
  getOwner = (ownerUserId, item) => {
    if (!item) {
      return null
    }
    if (ownerUserId) {
      return getObjectOwner(item, ownerUserId)
    } else if (item.posseduto_da.length === 1) {
      // Onwed only one user so is the uniqe owner
      return item.posseduto_da[0]
    }
    return null
  }

  // My conditions on item
  // if not owned by me return undefined
  getMyItemConditions = () => {
    const { user } = this.props
    const owner = this.getOwner(this.props.ownerUserId, this.props.item)

    // Not owned by me
    if (!owner || owner.user.id !== user.id) {
      return null
    }

    // Basic condition object
    let conditions = omit(owner, 'user')

    // Replace note \w descrizione
    conditions['descrizione'] = conditions.note
    unset(conditions, 'note')

    // Condizioni to int for matching select
    conditions.condizioni = +conditions.condizioni
    conditions.condizioni2 = +(conditions.condizioni2 || null)

    return conditions
  }

  getItemForBuy = () => {
    const owner = this.getOwner(this.props.ownerUserId, this.props.item)
    if (owner) {
      return {
        money: owner.valore,
        requestedMoney: owner.valore,
      }
    }
    return null
  }

  submitOwned = (conditions, dispatch) => {
    const { api, item } = this.props
    return api.iOwn(item.id, conditions)
  }

  submitOwnedSuccess = item => {
    const { user } = this.props
    this.toggleOwnedFormOpen()
    this.props.ownedItemUpdated(item)
    this.props.history.replace(`${item.id}?userId=${user.id}`)
  }

  submitUpdate = (conditions, dispatch) => {
    const { api, item } = this.props
    return api.updateOwnedItem(item.id, conditions)
  }

  submitUpdateSuccess = item => {
    this.props.ownedItemUpdated(item)
    this.toggleEditFormOpen()
  }

  submitBuy = ({ money }) => {
    const itemId = this.props.item.id
    const owner = this.getOwner(this.props.ownerUserId, this.props.item)
    const userId = this.props.user.id
    return this.props.api.buyItem(itemId, owner.user.id, userId, +money)
  }

  submitBuySuccess = swap => {
    this.toggleBuyFormOpen()
    this.props.history.push(`/swap/${swap.id}`)
  }

  handleSwap = () => {
    const { userCanSwap } = this.props
    if (userCanSwap) {
      const { item, ownerUserId, givenItemId } = this.props
      const owner = this.getOwner(ownerUserId, item)
      const swapLink = `/swap/new/${owner.user.id}?items=${item.id}`
      if (givenItemId) {
        this.props.history.push(`${swapLink}&givenItems=${givenItemId}`)
      } else {
        this.props.history.push(swapLink)
      }
    } else {
      this.toggleUserCantSwapModalOpen()
    }
  }

  render() {
    const {
      user,
      ownerUserId,
      error,
      loading,
      item,
      givenItemId,
      canSwap,
      canSwapLoading,
      canProposeSwap,
      canProposeSwapLoading,
      wantedLoading,
      iWant,
      iWantNot,
      setItemNotOwned,
      removingInterest,
    } = this.props

    if (!item && loading) {
      return <Spinner centered />
    }

    if (!item && error) {
      return <ErrorPage error={error} />
    }

    // Check owner of object
    let owner = null
    if (item) {
      owner = this.getOwner(ownerUserId, item)
      if (ownerUserId && !owner) {
        return <NotFound />
      }
    }

    // Is a user interest?
    const isUserInterest = get(
      this.props.location,
      'state.isUserInterest',
      false
    )

    return (
      <div>
        {item &&
          <div>
            <ObjectDetail
              item={item}
              user={user}
              owner={owner}
              canSwap={canSwap}
              canSwapLoading={canSwapLoading}
              canProposeSwap={canProposeSwap}
              canProposeSwapLoading={canProposeSwapLoading}
              wantedLoading={wantedLoading}
              iWant={iWant}
              iWantNot={iWantNot}
              viewedImage={this.state.viewedImage}
              setViewedImage={this.setViewedImage}
              onBuyClick={this.toggleBuyFormOpen}
              onEditClick={this.toggleEditFormOpen}
              onOwnedClick={this.toggleOwnedFormOpen}
              onNotOwnedClick={this.toggleNotOwnedDialogOpen}
              onSwapClick={this.handleSwap}
              showDeleteInterest={isUserInterest}
              deletingInterest={removingInterest}
              removeInterestClick={this.toggleInterestModal}
            />

            {user &&
              <div>

                <ReactModal
                  isOpen={this.state.ownedFormOpen}
                  onRequestClose={this.toggleOwnedFormOpen}
                  contentLabel="aggiunta oggetto a possiedo"
                  style={{
                    overlay: {
                      zIndex: 1111,
                    },
                    content: {
                      position: 'fixed',
                      top: '0px',
                      bottom: '0px',
                      left: '0px',
                      right: '0px',
                      padding: 0,
                    },
                  }}>
                  <div style={modalStyles.header}>
                    <IconButton
                      onClick={this.toggleOwnedFormOpen}
                      iconStyle={{ color: themeColors.white }}>
                      <Close />
                    </IconButton>
                    <span>Aggiungi a possiedo</span>
                  </div>
                  <div style={modalStyles.scrolling}>
                    <OwnedForm
                      item={item}
                      toggleOpen={this.toggleOwnedFormOpen}
                      conditions={getObjectConditions(item.categoria.id)}
                      onSubmit={this.submitOwned}
                      onSubmitSuccess={this.submitOwnedSuccess}
                    />
                  </div>
                </ReactModal>

                <Dialog
                  titleStyle={{ backgroundColor: themeColors.lightBackground }}
                  title="Eliminazione Interesse"
                  modal={false}
                  contentClassName="fullwidth-for-small"
                  open={this.state.removeInterestOpen}
                  onRequestClose={this.toggleInterestModal}
                  actions={[
                    <FlatButton
                      onClick={this.toggleInterestModal}
                      label="Annulla"
                      primary={true}
                    />,
                    <FlatButton
                      label="Ok"
                      primary={true}
                      onClick={() => {
                        this.props.removeInterest(item)
                        this.toggleInterestModal()
                      }}
                    />,
                  ]}>
                  <p>
                    Confermi l'eliminazione dell'interesse di
                    {' '}
                    <b>{item.titolo}</b>
                    ?
                  </p>
                </Dialog>

                <Dialog
                  title="Modifica Condizioni"
                  titleStyle={{ backgroundColor: themeColors.lightBackground }}
                  modal={false}
                  open={this.state.editFormOpen}
                  onRequestClose={this.toggleEditFormOpen}
                  autoScrollBodyContent={true}
                  contentClassName="fullwidth-for-small">
                  <OwnedForm
                    item={item}
                    initialValues={this.getMyItemConditions()}
                    toggleOpen={this.toggleEditFormOpen}
                    conditions={getObjectConditions(item.categoria.id)}
                    onSubmit={this.submitUpdate}
                    onSubmitSuccess={this.submitUpdateSuccess}
                  />
                </Dialog>

                <Dialog
                  title="Togli da possiedo"
                  titleStyle={{ backgroundColor: themeColors.lightBackground }}
                  contentClassName="fullwidth-for-small"
                  modal={false}
                  open={this.state.notOwnedDialogOpen}
                  onRequestClose={this.toggleNotOwnedDialogOpen}
                  actions={[
                    <FlatButton
                      label="Annulla"
                      primary={true}
                      onClick={this.toggleNotOwnedDialogOpen}
                    />,
                    <FlatButton
                      label="Ok"
                      primary={true}
                      keyboardFocused={true}
                      onClick={() => {
                        this.toggleNotOwnedDialogOpen()
                        setItemNotOwned(item.id, user.id)
                      }}
                    />,
                  ]}
                  autoScrollBodyContent={true}>
                  <p>Confermi di non possedere più {item.titolo}?</p>
                </Dialog>

                <Dialog
                  title="Compra"
                  contentClassName="fullwidth-for-small"
                  titleStyle={{ backgroundColor: themeColors.lightBackground }}
                  modal={false}
                  open={this.state.buyFormOpen}
                  onRequestClose={this.toggleBuyFormOpen}
                  autoScrollBodyContent={true}>
                  <BuyForm
                    item={item}
                    owner={owner}
                    initialValues={this.getItemForBuy()}
                    toggleOpen={this.toggleBuyFormOpen}
                    onSubmit={this.submitBuy}
                    onSubmitSuccess={this.submitBuySuccess}
                  />
                </Dialog>

                <Dialog
                  title="Indirizzo Mancante"
                  titleStyle={{ backgroundColor: themeColors.lightBackground }}
                  contentClassName="fullwidth-for-small"
                  modal={false}
                  open={this.state.userCantSwapModalOpen}
                  onRequestClose={this.toggleUserCantSwapModalOpen}
                  actions={[
                    <FlatButton
                      label="Annulla"
                      primary={true}
                      onClick={this.toggleUserCantSwapModalOpen}
                    />,
                    <FlatButton
                      label="Completa Profilo"
                      primary={true}
                      keyboardFocused={true}
                      onClick={() => {
                        let swapLink = `/swap/new/${owner.user.id}?items=${item.id}`
                        if (givenItemId) {
                          swapLink += `&givenItems=${givenItemId}`
                        }
                        this.props.history.push('/profile/edit', {
                          redirectToSwap: swapLink,
                        })
                      }}
                    />,
                  ]}
                  autoScrollBodyContent={true}>
                  <p>
                    Attenzione: completa i tuoi dati personali per poter effettuare scambi.
                  </p>
                </Dialog>
              </div>}
          </div>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  api: makeAuthenticatedApi(state), // <--- Curried authentictation
  user: state.auth.user,
  userCanSwap: getUserCanSwap(state),
  ownerUserId: parseQsId(ownProps.location, 'userId'),
  givenItemId: parseQsId(ownProps.location, 'givenItem'),
  item: state.itemDetail.item,
  canSwap: state.itemDetail.canSwap,
  canSwapLoading: state.itemDetail.canSwapLoading,
  canProposeSwap: state.itemDetail.canProposeSwap,
  canProposeSwapLoading: state.itemDetail.canProposeSwapLoading,
  loading: state.itemDetail.loading,
  wantedLoading: state.itemDetail.wantedLoading,
  error: state.itemDetail.error,
  removingInterest: state.itemDetail.removingInterest,
  interestRemoved: state.itemDetail.interestRemoved,
})

export default connect(mapStateToProps, {
  getItemDetail,
  unloadItemDetail,
  iWant,
  iWantNot,
  setItemNotOwned,
  ownedItemUpdated,
  checkCanSwapItem,
  checkCanProposeSwapItem,
  removeInterest,
})(ObjectDetailPage)



// WEBPACK FOOTER //
// ./src/pages/ObjectDetail.js